import React from "react";

import { FormItem } from "src/base-components/FormItem";
import {
  type HeaderEntry,
  SampleHeadersEditor,
} from "src/connections/config/SampleHeadersEditor";
import { Accordion } from "src/design-system/Accordion";
import { CodeNodeEditor } from "src/nodeEditor/CodeNodeEditor";

type SampleResponseConfigurationProps = {
  headerEntries: HeaderEntry[];
  immutable: boolean;
  value: string;
  onHeaderEntriesChange: (entries: HeaderEntry[]) => void;
  onChange: (value: string) => void;
};

export const SampleResponseConfiguration: React.FC<
  SampleResponseConfigurationProps
> = ({ headerEntries, immutable, value, onHeaderEntriesChange, onChange }) => {
  return (
    <div className="mb-2">
      <Accordion dataLoc="sample-response-accordion">
        <Accordion.Item
          label="Configure sample response"
          value="sample-response"
        >
          <div className="flex flex-col gap-2">
            <FormItem gap="xs" label="Headers">
              <SampleHeadersEditor
                dataLoc="sample-response-headers"
                disabled={immutable}
                entries={headerEntries}
                onChange={onHeaderEntriesChange}
              />
            </FormItem>
            <FormItem gap="xs" label="Body">
              <div className="h-56">
                <CodeNodeEditor
                  displayedError={undefined}
                  immutable={immutable}
                  isReactive={false}
                  language={undefined}
                  src={value}
                  onChange={(content) => {
                    if (content !== undefined) {
                      onChange(content);
                    }
                  }}
                />
              </div>
            </FormItem>
          </div>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};
